// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"water-regional_wrapper__3RvYn"};